/**
* Sufixos de subclasse aceitos pela Comdinheiro. O mesmo fundo pode responder pela forma
* com letra OU pela forma com número, dependendo de como está cadastrado lá — por isso o
* sufixo é definido por consulta (NewFund.js) e não por convenção.
*/

const SUBCLASS_SUFFIXES = [
    'subclassea', 'subclasseb', 'subclassec', 'subclassed',
    'subclasse1', 'subclasse2', 'subclasse3', 'subclasse4',
];

/**
* @return {Array} Array com os sufixos de subclasse possíveis
*/
export function getSubclassSuffixesComdinheiro() {

    return SUBCLASS_SUFFIXES;
}

/**
* funds.subclass guarda o token literal (ex.: 'subclassea'). O branch de legado cobre bases
* ainda não migradas (migration 91), onde o campo guardava o rótulo 'SUB CLASSE A' e sempre
* era resolvido para a forma numérica.
* @return {string|null} sufixo normalizado ou null quando não reconhecido
*/
export function normalizeSubclassSuffix(subclass) {

    if (!subclass) return null;

    const value = subclass.toString().trim().toLowerCase();
    if (SUBCLASS_SUFFIXES.includes(value)) return value;

    const legacy = value.split(' ').join('').replace(/[a-z]$/, l => String(l.charCodeAt(0) - 96));
    return SUBCLASS_SUFFIXES.includes(legacy) ? legacy : null;
}

/**
* @return {string} rótulo de exibição do sufixo (ex.: 'SUB CLASSE A')
*/
export function getSubclassSuffixLabel(suffix) {

    if (!suffix) return 'SEM SUB CLASSE';

    return 'SUB CLASSE ' + suffix.slice('subclasse'.length).toUpperCase();
}
